import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type DeleteScimApiKeyMutationVariables = GraphQLTypes.Exact<{
  id: GraphQLTypes.Scalars['String']['input'];
}>;

export type DeleteScimApiKeyMutationResult = { __typename?: 'Mutation' } & {
  deleteScimApiKey?: GraphQLTypes.Maybe<
    { __typename?: 'DeleteScimApiKeyPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'path'>>>;
    }
  >;
};

export const DeleteScimApiKeyDocument = gql`
  mutation deleteScimApiKey($id: String!) {
    deleteScimApiKey(id: $id) {
      errors {
        path
      }
    }
  }
`;
